import React, { useCallback, useEffect, useState, useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import Footer from "../../component/Footer";
import Header from "../../component/Header";
import "./Checkout.css";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import axios from "../../helper/axios";
import LoadingImg from "./loading.gif";
import ErrorModal from "./Errormodal";
// LOYALTY_UI_DISABLED: import LoyaltyHelpModal from "./LoyaltyHelpModal";
import Toasts from "../../component/Common/Toasts";
import { getCartItemDisplayPrice, isCartItemDiscounted, repriceCartItem } from "../../helper/discount";
import { trackInitiateCheckout } from "../../helper/analyticsConsent";
import { addToCart } from "../../action";

const isObjectEmpty = (obj) => {
  return Object.keys(obj).length === 0;
};

const BOXES_ORIGIN = "https://admin.boxes-ks.com";
const BOXES_IFRAME_BASE = "https://admin.boxes-ks.com/embed/pup-picker";

const getBoxesIframeSrc = () => {
  if (typeof window === "undefined") return BOXES_IFRAME_BASE;
  const url = new URL(BOXES_IFRAME_BASE);
  url.searchParams.set("origin", window.location.origin);
  return url.toString();
};

const normalizeBoxesMessageType = (type) =>
  String(type ?? "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "");

// LOYALTY_DISCOUNT_DISABLED
/*
const parseLoyaltyPercent = (discount) => {
  const match = String(discount ?? "").replace(",", ".").match(/(\d+(?:\.\d+)?)/);
  if (!match) return 0;
  const n = Number(match[1]);
  return Number.isFinite(n) && n > 0 && n <= 100 ? n : 0;
};

const formatLoyaltyPercent = (percent) => {
  const n = Number(percent) || 0;
  if (!n) return "";
  return Number.isInteger(n) ? String(n) : String(Number(n.toFixed(1)));
};
*/

const getBoxesLocationName = (pika) =>
  String(
    pika?.Name ??
      pika?.name ??
      pika?.Emri ??
      pika?.emri ??
      pika?.locationName ??
      pika?.LocationName ??
      pika?.pickUpLocationName ??
      pika?.Title ??
      pika?.title ??
      ""
  ).trim();

const extractBoxesPayload = (data) => {
  if (!data || typeof data !== "object") return null;
  const candidates = [
    data.payload,
    data.location,
    data.data,
    data.selectedLocation,
    data
  ];
  for (const item of candidates) {
    if (!item || typeof item !== "object") continue;
    const id =
      item.Id ??
      item.id ??
      item.ID ??
      item.locationId ??
      item.pickUpLocationId;
    if (id !== undefined && id !== null && String(id).trim() !== "") {
      return item;
    }
  }
  return null;
};

const isBoxesLocationSelectedMessage = (typeNorm, rawType) =>
  typeNorm === "locationselected" ||
  String(rawType ?? "").trim() === "Location Selected";

const isBoxesCloseIframeMessage = (typeNorm, rawType) => {
  if (
    typeNorm === "pup-picker:close" ||
    typeNorm === "pup-picker:confirm" ||
    typeNorm === "pup-picker:confirmed" ||
    typeNorm === "locationconfirmed"
  ) {
    return true;
  }
  const raw = String(rawType ?? "").toLowerCase();
  return raw.includes("pup-picker") && raw.includes("confirm");
};

const getShippingLetter = (mode) => {
  if (Array.isArray(mode)) return String(mode[0] || "").trim();
  if (typeof mode === "string") return (mode.split(",")[0] || "").trim();
  return "";
};

const getShippingChargeFromMode = (mode) => {
  if (Array.isArray(mode)) return Number(mode[2] ?? 3);
  const parts = String(mode || "").split(",");
  const charge = Number(parts[1]);
  return Number.isFinite(charge) ? charge : 3;
};

// AL (+355) and MK (+389): always 6€ shipping (out-of-country)
const INTL_PHONE_PREFIXES = new Set(["+355", "+389"]);
const isIntlShippingPrefix = (prefix) =>
  INTL_PHONE_PREFIXES.has(String(prefix || "").trim());

const getShippingPriceForTotal = (_total, phonePrefix) => {
  if (isIntlShippingPrefix(phonePrefix)) return 6;
  return 3;
};

const parseMaybeJson = (data) => {
  if (data == null) return null;
  if (typeof data === "object") return data;
  if (typeof data === "string") {
    try {
      return JSON.parse(data);
    } catch {
      return null;
    }
  }
  return null;
};

const isBoxesOrigin = (origin) =>
  typeof origin === "string" && origin.includes("boxes-ks.com");

const logBoxesToTerminal = (payload) => {
  if (process.env.NODE_ENV !== "development") return;
  axios.post("/boxes-debug-log", payload).catch(() => {});
};
export default function Checkout() {
  const dispatch = useDispatch();
  const UniqueId = useRef(
    Math.floor(1000000000 + Math.random() * 9000000000)
  ).current;
  const submittingRef = useRef(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm();
  const prefilledUserIdRef = useRef(null);
  const auth = useSelector((state) => state?.productData?.users);
  const isLoggedIn = Boolean(auth?.user?.email);

  const navigate = useNavigate();
  const [anyComment, setanyComment] = useState();
  const [paymentParams, setPaymentParams] = useState([]);
  // const [paymentMethod,setpaymentMethod] = useState("cod");
  const cartData = useSelector((state) => state.cart?.cartItems);

  const [deliverMode, setdeliverMode] = useState("t,3");
  const [paymentMode, setpaymentMode] = useState("");
  const [paymentModex, setpaymentModex] = useState("");
  const [deliverModex, setdeliverModex] = useState("");
  const [phonePrefix, setPhonePrefix] = useState("+383");
  const [transportCharge, setTransportCharge] = useState(3);
  const [boxesPickerClosed, setBoxesPickerClosed] = useState(false);
  const [boxesIframeSrc] = useState(() => getBoxesIframeSrc());
  const [boxesPickupData, setBoxesPickupData] = useState({
    BoxesId: "",
    BoxesName: "",
    BoxesAddress: "",
    BoxesCity: ""
  });
  const boxesPickupRef = useRef({
    BoxesId: "",
    BoxesName: "",
    BoxesAddress: "",
    BoxesCity: ""
  });
  const [modalOpen, setModalOpen] = useState(false);
  const [errorMsg] = useState("");
  const [loadingBox, setLoadingBox] = useState(false);
  const [productPriceData, setProductPriceData] = useState({}); // keyed by product _id/externalId
  const [promotionSummary, setPromotionSummary] = useState({
    total: 0,
    discount: 0,
    finalTotal: 0,
    appliedPromotions: [],
    items: [],
  });
  const [promocodeInput, setPromocodeInput] = useState("");
  const [promocodeApplied, setPromocodeApplied] = useState(null); // { code, discount: {type,value,amount?}, allowDiscountedItems }
  // LOYALTY_DISCOUNT_DISABLED
  // const [loyaltyApplied, setLoyaltyApplied] = useState(null); // { code, points, tierName, discount, percent }
  const [showPromoSection, setShowPromoSection] = useState(false);
  // const [loyaltyHelpOpen, setLoyaltyHelpOpen] = useState(false);
  const checkoutTrackedRef = useRef(false);
  const repricedOnceRef = useRef(false);

  const getProductDetailsForItem = (item) => productPriceData[item?._id || item?.externalId];

  const isDiscountActive = (item) => isCartItemDiscounted(item, getProductDetailsForItem(item));

  // Display only - order totals are recalculated by the API
  function getDisplayPrice(item) {
    return getCartItemDisplayPrice(item, getProductDetailsForItem(item));
  }

  const getCartItemUnitPrice = (item, promoItem) => {
    if (promoItem?.finalUnitPrice > 0) return Number(promoItem.finalUnitPrice);
    const p = getDisplayPrice(item);
    if (p.hasDiscount2 && p.sale2 > 0) return Number(p.sale2);
    if (p.hasDiscount && p.sale > 0) return Number(p.sale);
    return Number(p.regular || 0);
  };

  const normalizeLocationCode = (val) => {
    const s = val === undefined || val === null ? "" : String(val);
    return s.trim();
  };

  const promocodeLocationAllowsItem = (promo, item) => {
    const modeRaw = promo?.locations?.mode;
    const mode = modeRaw ? String(modeRaw).trim().toLowerCase() : "all";
    if (!mode || mode === "all") return true;
    if (mode !== "specific") return true;
    const list = Array.isArray(promo?.locations?.list) ? promo.locations.list : [];
    if (!list.length) return false;

    const itemLoc = normalizeLocationCode(
      item?.location ?? item?.attributes?.location
    );
    if (!itemLoc) return false;

    const allowed = new Set(list.map((x) => normalizeLocationCode(x)).filter(Boolean));
    return allowed.has(itemLoc);
  };

  function calculatePromocodeAmountLocal(promo) {
    if (!promo?.code || !promo?.discount?.type || !promo?.discount?.value) return 0;
    const dtype = promo.discount.type;
    const dval = Number(promo.discount.value || 0);
    if (!dval || dval <= 0) return 0;

    let eligibleSubtotal = 0;
    cartData.forEach((item) => {
      if (!promocodeLocationAllowsItem(promo, item)) return;
      const displayPrice = getDisplayPrice(item);
      const regular = Number(displayPrice.regular || 0);
      const sale =
        displayPrice.hasDiscount2 && displayPrice.sale2 > 0
          ? Number(displayPrice.sale2 || 0)
          : (displayPrice.hasDiscount && displayPrice.sale > 0
              ? Number(displayPrice.sale || 0)
              : Number(displayPrice.regular || 0));
      const hasItemDiscount = regular > 0 && sale > 0 && sale < regular;
      const allowed = promo.allowDiscountedItems !== false ? true : !hasItemDiscount;
      if (!allowed) return;
      eligibleSubtotal += Math.max(0, sale) * (item.quantity || 1);
    });

    if (eligibleSubtotal <= 0) return 0;
    if (dtype === "percentage") {
      return Math.max(0, Math.min(eligibleSubtotal, (eligibleSubtotal * dval) / 100));
    }
    if (dtype === "fixed") {
      return Math.max(0, Math.min(eligibleSubtotal, dval));
    }
    return 0;
  }

  // Per-item coupon allocation for UI (so the discount shows on each row)
  const promocodeAllocation = useMemo(() => {
    if (!promocodeApplied?.code) return { byKey: {}, total: 0 };

    const couponDiscountRaw = Number(
      promocodeApplied?.discount?.amount ||
        calculatePromocodeAmountLocal(promocodeApplied)
    );
    const couponDiscount = Math.max(0, couponDiscountRaw);
    if (!couponDiscount) return { byKey: {}, total: 0 };

    const allowDiscountedItems = promocodeApplied.allowDiscountedItems !== false;

    const entries = (cartData || []).map((dtt) => {
      const key = dtt.uniqueId || `${dtt._id}-${dtt.item_code}`;
      const displayPrice = getDisplayPrice(dtt);
      const regular = Number(displayPrice.regular || 0);
      const unit = getCartItemUnitPrice(dtt, null);
      const qty = Number(dtt.quantity || 1);
      const hasItemDiscount = regular > 0 && unit > 0 && unit < regular;
      const allowed = allowDiscountedItems ? true : !hasItemDiscount;
      const locAllowed = promocodeLocationAllowsItem(promocodeApplied, dtt);
      const lineSubtotal = allowed && locAllowed
        ? Math.max(0, unit) * Math.max(1, qty)
        : 0;
      return { key, lineSubtotal, qty };
    });

    const eligibleSubtotal = entries.reduce((s, e) => s + e.lineSubtotal, 0);
    if (eligibleSubtotal <= 0) return { byKey: {}, total: 0 };

    // Allocate proportionally; keep cents consistent by adjusting last eligible line
    const byKey = {};
    let remaining = Number(couponDiscount.toFixed(2));
    const elig = entries.filter((e) => e.lineSubtotal > 0);
    elig.forEach((e, idx) => {
      if (idx === elig.length - 1) {
        byKey[e.key] = Number(Math.max(0, remaining).toFixed(2));
        return;
      }
      const share = (couponDiscount * e.lineSubtotal) / eligibleSubtotal;
      const amt = Number(Math.max(0, share).toFixed(2));
      byKey[e.key] = amt;
      remaining = Number((remaining - amt).toFixed(2));
    });

    return { byKey, total: Number(couponDiscount.toFixed(2)) };
  }, [cartData, promocodeApplied]);

  // LOYALTY_DISCOUNT_DISABLED: zbritja e loyalty nuk llogaritet në checkout.
  const loyaltyAllocation = useMemo(() => ({ byKey: {}, total: 0, percent: 0 }), []);
  /*
  const loyaltyAllocation = useMemo(() => {
    const percent =
      Number(loyaltyApplied?.percent) ||
      parseLoyaltyPercent(loyaltyApplied?.discount);
    if (!loyaltyApplied || !percent) return { byKey: {}, total: 0, percent: 0 };

    const hasPromocode =
      promocodeApplied?.code && Number(promocodeAllocation?.total || 0) > 0;
    if (hasPromocode) return { byKey: {}, total: 0, percent };

    const byKey = {};
    let total = 0;
    (cartData || []).forEach((item) => {
      const displayPrice = getDisplayPrice(item);
      const hasProductSale =
        isDiscountActive(item) ||
        (displayPrice.hasDiscount2 &&
          displayPrice.sale2 > 0 &&
          displayPrice.regular > 0 &&
          displayPrice.sale2 < displayPrice.regular) ||
        (displayPrice.hasDiscount &&
          displayPrice.sale > 0 &&
          displayPrice.regular > 0 &&
          displayPrice.sale < displayPrice.regular);
      if (hasProductSale) return;

      const promoItem =
        promotionSummary.items?.find(
          (pi) =>
            (pi.uniqueId && pi.uniqueId === item.uniqueId) ||
            (!pi.uniqueId &&
              pi.externalId === (item._id || item.externalId) &&
              pi.item_code === item.item_code)
        ) || null;
      if (
        promoItem &&
        Number(promoItem.finalUnitPrice) > 0 &&
        Number(promoItem.baseUnitPrice) > 0 &&
        Number(promoItem.finalUnitPrice) < Number(promoItem.baseUnitPrice)
      ) {
        return;
      }

      const key = item.uniqueId || `${item._id}-${item.item_code}`;
      const unit = getCartItemUnitPrice(item, null);
      const qty = Number(item.quantity || 1);
      const line = Math.max(0, unit) * Math.max(1, qty);
      const amt = Number(((line * percent) / 100).toFixed(2));
      if (amt <= 0) return;
      byKey[key] = amt;
      total += amt;
    });

    return { byKey, total: Number(total.toFixed(2)), percent };
  }, [cartData, loyaltyApplied, promocodeApplied, promocodeAllocation, productPriceData, promotionSummary]);
  */

  // Calculate total based on validated display prices (reactive to productPriceData and cartData)
  const validatedTotal = useMemo(() => {
    if (!cartData || cartData.length === 0) return 0;

    let total = 0;
    cartData.forEach((item) => {
      const displayPrice = getDisplayPrice(item);
      const itemPrice =
        displayPrice.hasDiscount2 && displayPrice.sale2 > 0
          ? displayPrice.sale2
          : (displayPrice.hasDiscount && displayPrice.sale > 0
              ? displayPrice.sale
              : displayPrice.regular);
      total += itemPrice * (item.quantity || 1);
    });

    

    return total;
  }, [cartData, getDisplayPrice]);

  const checkoutTotals = useMemo(() => {
    const hasPromoTotal =
      promotionSummary.discount &&
      promotionSummary.discount > 0 &&
      promotionSummary.total &&
      promotionSummary.total > 0;
    const baseTotal = hasPromoTotal ? promotionSummary.total : validatedTotal;
    const promoDiscount = hasPromoTotal ? promotionSummary.discount : 0;
    const couponDiscount = promocodeApplied
      ? Math.max(0, Number(promocodeAllocation?.total || 0))
      : 0;
    const loyaltyDiscount = Math.max(0, Number(loyaltyAllocation?.total || 0));
    const merchandise = Math.max(
      0,
      baseTotal - promoDiscount - couponDiscount - loyaltyDiscount
    );
    return {
      baseTotal,
      promoDiscount,
      couponDiscount,
      loyaltyDiscount,
      merchandise,
    };
  }, [
    promotionSummary,
    validatedTotal,
    promocodeApplied,
    promocodeAllocation,
    loyaltyAllocation,
  ]);

  useEffect(() => {
    if (checkoutTrackedRef.current) return;
    if (!cartData || cartData.length === 0) return;

    checkoutTrackedRef.current = true;
    try {
      trackInitiateCheckout({
        value: validatedTotal,
        items: cartData,
      });
    } catch (e) {
      // ignore tracking errors
    }
  }, [cartData, validatedTotal]);

  // Fetch fresh product data and reprice persisted cart.
  useEffect(() => {
    const fetchFreshPriceData = async () => {
      if (!cartData || cartData.length === 0) return;

      try {
        const priceDataMap = {};
        const promises = cartData.map(async (item) => {
          try {
            const productId = item?._id || item?.externalId;
            const dataId = {
              _id: productId,
              location: item?.location || ""
            };
            const res = await axios.post("/getproductbyid", dataId);
            if (res?.data?.length > 0) {
              const preferred =
                (item?.location &&
                  res.data.find(
                    (row) =>
                      String(row?.productDetails?.location || row?.location || "") ===
                      String(item.location)
                  )) ||
                res.data[0];
              const productDetails = preferred?.productDetails;
              priceDataMap[`${productId}::${item?.location || ""}`] = productDetails;
              priceDataMap[productId] = productDetails;
            }
          } catch (error) {
            console.error(`Error fetching price data for ${item?._id}:`, error);
          }
        });

        await Promise.all(promises);
        setProductPriceData(priceDataMap);

        // Re-price cart using latest DB prices (persisted cart can be stale).
        // Guard: avoid dispatch loop by only repricing once after hydration / when cart structure changes.
        if (repricedOnceRef.current) return;

        const updated = (cartData || []).map((it) => {
          const productId = it?._id || it?.externalId;
          const productDetails =
            priceDataMap[`${productId}::${it?.location || ""}`] ||
            priceDataMap[productId];
          const p = repriceCartItem(it, productDetails);
          return { ...it, ...p };
        });

        if (updated.length > 0) {
          const totalPrice = updated.reduce((acc, it) => {
            const unit =
              Number(it?.sale_price || 0) > 0
                ? Number(it.sale_price)
                : Number(it?.regular_price || 0);
            return acc + unit * Number(it?.quantity || 1);
          }, 0);
          updated[0] = { ...updated[0], totalPrice: Number(totalPrice.toFixed(2)) };
        }

        const changed = (cartData || []).some((oldIt, idx) => {
          const nextIt = updated[idx];
          if (!nextIt) return false;
          return (
            Number(oldIt?.regular_price || 0) !== Number(nextIt?.regular_price || 0) ||
            Number(oldIt?.sale_price || 0) !== Number(nextIt?.sale_price || 0)
          );
        });

        if (changed) dispatch(addToCart(updated));
        repricedOnceRef.current = true;
      } catch (error) {
        console.error("Error fetching fresh price data:", error);
      }
    };

    fetchFreshPriceData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartData]); // Re-run when cart changes / after refresh

  // Fetch promotion preview for current cart so klienti e sheh zbritjen në checkout
  useEffect(() => {
    const fetchPromotionPreview = async () => {
      if (!cartData || cartData.length === 0) {
        setPromotionSummary({
          total: 0,
          discount: 0,
          finalTotal: 0,
          appliedPromotions: [],
        });
        return;
      }

      try {
        const res = await axios.post("/checkout/promotions-preview", {
          productList: cartData,
        });
        if (res?.data) {
          setPromotionSummary({
            total: Number(res.data.total || 0),
            discount: Number(res.data.discount || 0),
            finalTotal: Number(res.data.finalTotal || 0),
            appliedPromotions: Array.isArray(res.data.appliedPromotions)
              ? res.data.appliedPromotions
              : [],
            items: Array.isArray(res.data.items) ? res.data.items : [],
          });
        }
      } catch (err) {
        console.error("promotion preview error:", err);
        setPromotionSummary((prev) => ({
          ...prev,
          discount: 0,
          finalTotal: prev.total || validatedTotal,
          items: [],
        }));
      }
    };

    fetchPromotionPreview();
  }, [cartData, validatedTotal]);

  const notifyErr = (msg) => toast.error(msg);
  const notifyOk = (msg) => toast.success(msg);

  const cart = useSelector((state) => state.cart);
  var sum = 0;
  var finalObj = [];
  for (var item in cart.cartItems) {
    finalObj.push(cart.cartItems[item]);
  }

  for (let key in cart.cartItems) {
    sum += cart.cartItems[key].totalPrice;
  }

  const vendorIdData = cart?.cartItems[0]?.vendorId;

  useEffect(() => {
    if (!isObjectEmpty(errors)) {
      window.scrollTo(0, 0);
    }
  }, [errors]);

  const applyBoxesPickup = useCallback((pika) => {
    const pickupId =
      pika?.Id ??
      pika?.id ??
      pika?.ID ??
      pika?.locationId ??
      pika?.pickUpLocationId ??
      "";
    const next = {
      BoxesId:
        pickupId !== "" && pickupId != null ? String(pickupId) : "",
      BoxesName: getBoxesLocationName(pika),
      BoxesAddress: String(
        pika?.Adresa || pika?.address || pika?.Address || ""
      ),
      BoxesCity: String(pika?.City || pika?.city || "")
    };
    setBoxesPickupData(next);
    boxesPickupRef.current = next;
    setdeliverModex("");
  }, []);

  useEffect(() => {
    const letter = getShippingLetter(deliverMode);
    if (letter === "b") {
      setBoxesPickerClosed(false);
      return;
    }
    const empty = { BoxesId: "", BoxesName: "", BoxesAddress: "", BoxesCity: "" };
    setBoxesPickupData(empty);
    boxesPickupRef.current = empty;
  }, [deliverMode]);

  useEffect(() => {
    const handleBoxesMessage = (event) => {
      if (!isBoxesOrigin(event.origin)) return;

      const data = parseMaybeJson(event?.data);
      if (!data || typeof data !== "object") return;

      const rawType = data.type;
      const typeNorm = normalizeBoxesMessageType(rawType);

      if (process.env.NODE_ENV === "development") {
        console.log("[Boxes] postMessage", {
          origin: event.origin,
          type: rawType,
          data
        });
      }

      logBoxesToTerminal({
        origin: event.origin,
        type: rawType,
        data
      });

      const payload = extractBoxesPayload(data);
      if (payload) {
        applyBoxesPickup(payload);
        if (process.env.NODE_ENV === "development") {
          console.log("[Boxes] pickup saved", payload);
        }
        logBoxesToTerminal({
          origin: event.origin,
          type: rawType,
          data,
          saved: {
            BoxesId: String(
              payload.Id ??
                payload.id ??
                payload.ID ??
                payload.locationId ??
                ""
            ),
            BoxesAddress: String(payload.Adresa || payload.address || ""),
            BoxesCity: String(payload.City || payload.city || "")
          },
          note: "pickup saved to checkout state"
        });
      }

      if (isBoxesCloseIframeMessage(typeNorm, rawType)) {
        setBoxesPickerClosed(true);
        logBoxesToTerminal({
          origin: event.origin,
          type: rawType,
          data,
          note: "iframe close / confirm"
        });
        return;
      }

      if (isBoxesLocationSelectedMessage(typeNorm, rawType)) {
        return;
      }
    };

    window.addEventListener("message", handleBoxesMessage);
    return () => window.removeEventListener("message", handleBoxesMessage);
  }, [applyBoxesPickup]);

  const checkoutData = async (datax) => {
    if (submittingRef.current) return;

    if (!cartData || cartData.length === 0) {
      notifyErr("Shporta është e zbrazët.");
      return;
    }

    if (paymentMode === "") {
      setpaymentModex("Please select payment method");
      const paymentMethod = document.getElementById("paymentMethod");
      paymentMethod.scrollIntoView({ behavior: "smooth", block: "center" });
    } else if (!deliverMode) {
      setdeliverModex("Ju lutem zgjidhni mënyrën e dërgesës");
      const orderDelivery = document.getElementById("orderDelivery");
      orderDelivery.scrollIntoView({ behavior: "smooth", block: "center" });
    } else if (
      getShippingLetter(deliverMode) === "b" &&
      (!boxesPickupRef.current?.BoxesId ||
        !boxesPickupRef.current?.BoxesAddress ||
        !boxesPickupRef.current?.BoxesCity)
    ) {
      setdeliverModex("Ju lutem zgjidhni një pikë Boxes për dorëzim");
      setBoxesPickerClosed(false);
      document
        .getElementById("boxes-shipping-section")
        ?.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    if (paymentMode !== "") {
      submittingRef.current = true;
      setLoadingBox(true);

      const shippingLetter = getShippingLetter(deliverMode);
      const isBoxesShipping = shippingLetter === "b";
      const pickupForOrder = boxesPickupRef.current || boxesPickupData;
      const shippingAmount =
        shippingLetter === "p"
          ? 0
          : getShippingPriceForTotal(checkoutTotals.merchandise, phonePrefix);

      const updatedCartData = cartData.map((item) => ({
        ...item,
        shipping_price: parseFloat(shippingAmount),
        grandTotal: item.sale_price + parseFloat(shippingAmount),
        totalPrice: finalObj[0].totalPrice + parseFloat(shippingAmount)
      }));

      const promoCodeToSend = promocodeApplied?.code
        ? String(promocodeApplied.code).trim()
        : String(promocodeInput || "").trim();

      if (promocodeApplied?.code) {
        try {
          const promoCheck = await axios.post("/checkout/promocode-validate", {
            code: promoCodeToSend,
          });
          if (!promoCheck?.data?.valid) {
            setPromocodeApplied(null);
            setPromocodeInput("");
            notifyErr(promoCheck?.data?.message || "Kuponi nuk është valid");
            submittingRef.current = false;
            setLoadingBox(false);
            return;
          }
        } catch (promoErr) {
          notifyErr("Gabim gjatë validimit të kuponit");
          submittingRef.current = false;
          setLoadingBox(false);
          return;
        }
      }

      // LOYALTY_DISCOUNT_DISABLED: ruhet vetëm loyalty id, pa zbritje.
      const loyaltyCodeToSend = String(auth?.user?.Loyalty_id || "").trim();
      /*
      const loyaltyCodeToSend = loyaltyApplied?.code
        ? String(loyaltyApplied.code).trim()
        : "";
      */

      const result = {
        items: updatedCartData?.map((i) => ({
          externalId: i._id,
          skuId: i.item_code,
          location: i.location || "",
          quantity: i.quantity || 1
        }))
      };

      try {
        const stockCheck = await axios.post(`/findProductStocks`, result);
        const stockResults = Array.isArray(stockCheck?.data?.results)
          ? stockCheck.data.results
          : [];

        if (stockResults.length !== updatedCartData.length) {
          notifyErr("Ka problem me produktin. Ju lutem hiqeni nga shporta dhe provoni përsëri.");
          submittingRef.current = false;
          setLoadingBox(false);
          return;
        }

        const problemItems = stockResults
          .map((item, idx) => {
            const cartItem = updatedCartData[idx] || {};
            const name = item?.name || cartItem.name || "Produkt";
            const requested = Number(cartItem.quantity || 1);
            const stock = Number(item?.quantity);
            const missing = !item?.found;
            const noStock =
              !Number.isFinite(stock) || stock <= 0 || stock < requested;
            return missing || noStock ? name : null;
          })
          .filter(Boolean);

        if (problemItems.length > 0) {
          const uniqueNames = [...new Set(problemItems)];
          notifyErr(
            "Ka problem me produktin. Ju lutem hiqeni nga shporta dhe provoni përsëri.\n\n" +
              uniqueNames.map((n) => `• ${n}`).join("\n")
          );
          submittingRef.current = false;
          setLoadingBox(false);
          return;
        }
      } catch (error) {
        console.error("Stock check error:", error);
        notifyErr("Nuk u verifikua stoku. Ju lutem provoni përsëri.");
        submittingRef.current = false;
        setLoadingBox(false);
        return;
      }

      const localPhone = String(datax.phone || "").trim();
      const prefix = String(phonePrefix || "").trim();

      var data = {
        fname: isLoggedIn ? auth?.user?.fname || datax.fname : datax.fname,
        lname: isLoggedIn ? auth?.user?.lname || datax.lname : datax.lname,
        email: auth?.user?.email || datax.email,
        address: datax.address1,
        city: datax.city,
        phonePrefix: prefix,
        phoneNumber: localPhone,
        anyComment: anyComment,
        paymentMode: paymentMode,
        productList: updatedCartData,
        deliverMode: shippingAmount,
        shippingMethod: isBoxesShipping ? "boxes" : "standard",
        BoxesId: isBoxesShipping ? pickupForOrder.BoxesId : "",
        BoxesAddress: isBoxesShipping ? pickupForOrder.BoxesAddress : "",
        BoxesCity: isBoxesShipping ? pickupForOrder.BoxesCity : "",
        vendorId: vendorIdData,
        transId: paymentParams?.transId ? paymentParams?.transId : UniqueId,
        promocode: promoCodeToSend,
        loyaltycode: loyaltyCodeToSend,
        // expectedLoyaltyDiscount: Number(checkoutTotals.loyaltyDiscount || 0)
        expectedLoyaltyDiscount: 0
      };

      try {
        const res = await axios.post(`/checkout`, { data });
        if (res.status === 200) {
          if (paymentMode === "credit_card") {
            // const amountData =
            //     parseFloat(cartData?.[0]?.totalPrice > 50 ?
            //         cartData?.[0]?.totalPrice :
            //         cartData?.[0]?.totalPrice + parseInt(deliverMode?.[2])).toFixed(2);

            // Added total amount coming from DB what is saved
            // const amountData = res?.data?.orders?.[0]?.productList.reduce((sum, item) => {
            //     return sum + (item.grandTotal || 0);
            // }, 0);

            const amountData = res?.data?.grandTotal;
            const orderIdFromServer = res?.data?.orders?.[0]?.orderId;

            console.log("[PAYMENT] redirecting to /pay with:", {
              orderId: orderIdFromServer,
              amount: amountData,
              transId: res?.data?.orders?.[0]?.transId,
              promocode: promoCodeToSend,
              paymentMode,
            });

            navigate("/pay", {
              state: {
                orderId: orderIdFromServer,
                amount: amountData,
                transId: res?.data?.orders?.[0]?.transId
              }
            });
          } else {
            navigate("/order-success?transId=" + res?.data?.orders?.[0]?.transId);
          }
        } else {
          submittingRef.current = false;
          setLoadingBox(false);
          notifyErr("Diçka shkoi keq! Ju lutem provoni përsëri.");
        }
      } catch (error) {
        submittingRef.current = false;
        setLoadingBox(false);
        console.error("Checkout error:", error);

        const responseData = error?.response?.data;
        const serverMessage =
          (typeof responseData === "string" && responseData) ||
          responseData?.message ||
          (typeof responseData?.error === "string" && responseData.error) ||
          "";
        if (
          typeof serverMessage === "string" &&
          serverMessage.toLowerCase().includes("përdorur")
        ) {
          setPromocodeApplied(null);
          setPromocodeInput("");
        }
        notifyErr(
          serverMessage || "Diçka shkoi keq! Ju lutem provoni përsëri."
        );
      }
    }
  };

  const applyPromocode = async () => {
    const code = String(promocodeInput || "").trim();
    if (!code) {
      notifyErr("Shkruaj kodin promocional");
      return;
    }
    try {
      // Send a lightweight preview list using current display prices
      const items = (cartData || []).map((it) => {
        const displayPrice = getDisplayPrice(it);
        const regular = Number(displayPrice.regular || 0);
        const sale =
          displayPrice.hasDiscount2 && displayPrice.sale2 > 0
            ? Number(displayPrice.sale2 || 0)
            : (displayPrice.hasDiscount && displayPrice.sale > 0
                ? Number(displayPrice.sale || 0)
                : Number(displayPrice.regular || 0));
        return {
          regular_price: regular,
          sale_price: sale,
          quantity: it.quantity || 1,
          location: it?.location ?? it?.attributes?.location ?? "",
        };
      });

      const res = await axios.post("/checkout/promocode-validate", { code, items });
      if (res?.data?.valid) {
        const promo = res.data;
        const localAmount = calculatePromocodeAmountLocal(promo);
        setPromocodeApplied({
          code: promo.code,
          discount: {
            type: promo.discount.type,
            value: promo.discount.value,
            amount: Number((promo.discount.amount ?? localAmount) || 0),
          },
          allowDiscountedItems: promo.allowDiscountedItems,
          locations: promo.locations || { mode: "all", list: [] },
          fromdate: promo.fromdate || null,
          todate: promo.todate || null,
        });
        notifyOk("Kodi i kuponit u aplikua");
      } else {
        setPromocodeApplied(null);
        notifyErr(res?.data?.message || "Kodi i kuponit nuk është valid");
      }
    } catch (e) {
      setPromocodeApplied(null);
      notifyErr("Gabim gjatë validimit të kodit promocional");
    }
  };

  const clearPromocode = () => {
    setPromocodeApplied(null);
    setPromocodeInput("");
  };

  const radioHandler = (event) => {
    const value = event.target.value;
    setdeliverMode(value);
    setTransportCharge(getShippingChargeFromMode(value));
    setdeliverModex("");
  };

  const radioPaymentMode = (event) => {
    setpaymentMode(event.target.value);
  };

  useEffect(() => {
    const shippingExtra = getShippingChargeFromMode(deliverMode);
    const ttlPrice = parseFloat(
      Number(cartData?.[0]?.totalPrice || 0) + Number(shippingExtra || 0)
    ).toFixed(2);
    const data = {
      clientId: "530015548",
      transId: UniqueId,
      amount: ttlPrice
    };
    setPaymentParams(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const user = auth?.user;
    if (!user?.email || !user?._id) return;
    if (prefilledUserIdRef.current === user._id) return;

    const prefillFromProfile = async () => {
      try {
        const res = await axios.post("/getupdateprofile", {
          email: user.email,
          id: user._id
        });
        const profile = res?.status === 200 ? res.data : null;
        const prefilled = {
          fname: profile?.fname || user.fname || "",
          lname: profile?.lname || user.lname || "",
          address1: profile?.address || "",
          city: profile?.city || "",
          phone: profile?.phoneNumber || "",
          email: user.email || ""
        };
        reset(prefilled);
        prefilledUserIdRef.current = user._id;
      } catch (error) {
        reset({
          fname: user.fname || "",
          lname: user.lname || "",
          email: user.email || ""
        });
        prefilledUserIdRef.current = user._id;
      }
    };

    prefillFromProfile();
  }, [auth?.user, reset]);

  // LOYALTY_DISCOUNT_DISABLED: mos ngarko zbritjen e loyalty në checkout.
  /*
  useEffect(() => {
    if (!isLoggedIn || !auth?.user?.email || !auth?.user?._id) return;
    if (loyaltyApplied) return;

    const loadLoyaltyDiscount = async () => {
      try {
        const res = await axios.post("/getloyaltypoints", {
          email: auth.user.email,
          id: auth.user._id,
        });
        const data = res.data;
        const code = String(
          data?.loyaltycode || auth.user.Loyalty_id || ""
        ).trim();
        if (!code) return;

        const activeTier =
          data?.loyalty?.find((tier) => tier.active) || data?.loyalty?.[0];
        const percent = parseLoyaltyPercent(activeTier?.discount);

        setLoyaltyApplied({
          code,
          points: data?.points ?? 0,
          tierName: activeTier?.name || "-",
          discount: activeTier?.discount || "-",
          percent,
        });
      } catch (_) {
        // pa loyalty në checkout nëse API dështon
      }
    };

    loadLoyaltyDiscount();
  }, [auth?.user, isLoggedIn, loyaltyApplied]);
  */

  return (
    <>
      <Header />

      <ErrorModal
        open={modalOpen}
        message={errorMsg}
        onClose={() => setModalOpen(false)}
      />

      {/* LOYALTY_UI_DISABLED
      <LoyaltyHelpModal
        open={loyaltyHelpOpen}
        loggedIn={isLoggedIn}
        onClose={() => setLoyaltyHelpOpen(false)}
      />
      */}

      <Toasts />

      <form onSubmit={handleSubmit(checkoutData)}>
        <div className="container mx-auto checkout-premium">
          <div className="CheckoutForm pl-4 pr-4">
            <div className="HeadingTitle">
              <h1>Procesi i porosisë</h1>
              <p className="checkout-premium__lead">
                Plotëso të dhënat për të përfunduar.
              </p>
            </div>
            <div className="w-full">
              <div className="w-12/12">
                <div className="Checkout__address-actions">
                  <h4 className="Checkout__address-actions__title">
                    Të dhënat
                  </h4>
                </div>
              </div>
            </div>
            <div className="flex flex-col lg:flex-row w-full formsection">
              <div className="w-full lg:w-6/12 leftsection">
                <div className="w-full flex flex-row gap-4">
                  <div className=" w-full form-group form-group">
                    <label htmlFor="billingFirstName" className="">
                      Emri{" "}
                    </label>
                    <input
                      id="billingFirstName"
                      type="text"
                      className={`form-control form-control${isLoggedIn ? " bg-gray-100 cursor-not-allowed" : ""}`}
                      readOnly={isLoggedIn}
                      {...register("fname", { required: true })}
                    />
                    {errors.fname && (
                      <span className="validationError">
                        Emri është i detyrueshëm
                      </span>
                    )}
                  </div>
                  <div id="fname" className="invalid-feedback">
                    Name is required
                  </div>
                  <div className="form-group w-full form-group">
                    <label htmlFor="billingLastName" className="">
                      Mbiemri
                    </label>
                    <input
                      id="billingLastName"
                      type="text"
                      className={`form-control form-control${isLoggedIn ? " bg-gray-100 cursor-not-allowed" : ""}`}
                      readOnly={isLoggedIn}
                      {...register("lname", { required: true })}
                    />
                    {errors.lname && (
                      <span className="validationError">
                        Mbiemri është i detyrueshëm
                      </span>
                    )}
                  </div>
                </div>

                {loadingBox ? (
                  <div className="gif-button text-white text-xl w-full">
                    <img src={LoadingImg} clas height="40" width="40" alt="" />
                    Mos e rifresko ose mbyll dritaren..
                  </div>
                ) : (
                  ""
                )}

                {/* Email field for guest checkout */}
                {!auth?.user?.email && (
                  <div className="form-group form-group w-full">
                    <label htmlFor="billingEmail" className="">
                      Email *
                    </label>
                    <input
                      id="billingEmail"
                      type="email"
                      className="form-control form-control"
                      {...register("email", {
                        required: true,
                        pattern: /^\S+@\S+$/i
                      })}
                    />
                    {errors.email && (
                      <span className="validationError">
                        Email është i detyrueshëm
                      </span>
                    )}
                  </div>
                )}

                <div className={"w-full flex flex-row gap-4"}>
                  <div className="form-group form-group w-full">
                    <label htmlFor="billingAddress" className="">
                      Adresa
                    </label>
                    <input
                      id="billingAddress"
                      type="text"
                      className="form-control form-control"
                      {...register("address1", { required: true })}
                    />
                    {errors.address1 && (
                      <span className="validationError">
                        Adresa është e detyrueshme
                      </span>
                    )}
                  </div>

                  <div className="form-group form-group w-full">
                    <div className="form-group">
                      <label htmlFor="billing.city" className="">
                        Qyteti
                      </label>
                      <select
                        id="city"
                        className="form-control"
                        {...register("city", { required: true })}
                      >
                        <option value="">
                          Zgjidhni qytetin
                        </option>
                        <option value="Prishtinë">Prishtinë</option>
                        <option value="Prizren">Prizren</option>
                        <option value="Ferizaj">Ferizaj</option>
                        <option value="Pejë">Pejë</option>
                        <option value="Gjakovë">Gjakovë</option>
                        <option value="Gjilan">Gjilan</option>
                        <option value="Mitrovicë">Mitrovicë</option>
                        <option value="Vushtrri">Vushtrri</option>
                        <option value="Suharekë">Suharekë</option>
                        <option value="Rahovec">Rahovec</option>
                        <option value="Drenas">Drenas</option>
                        <option value="Podujevë">Podujevë</option>
                        <option value="Lipjan">Lipjan</option>
                        <option value="Malishevë">Malishevë</option>
                        <option value="Kamenicë">Kamenicë</option>
                        <option value="Viti">Viti</option>
                        <option value="Deçan">Deçan</option>
                        <option value="Istog">Istog</option>
                        <option value="Klinë">Klinë</option>
                        <option value="Skënderaj">Skënderaj</option>
                        <option value="Dragash">Dragash</option>
                        <option value="Fushë Kosovë">Fushë Kosovë</option>
                        <option value="Kaçanik">Kaçanik</option>
                        <option value="Shtime">Shtime</option>
                        <option value="Obiliq">Obiliq</option>
                        <option value="Leposaviq">Leposaviq</option>
                        <option value="Graçanicë">Graçanicë</option>
                        <option value="Hani i Elezit">Hani i Elezit</option>
                        <option value="Zveçan">Zveçan</option>
                        <option value="Shtërpcë">Shtërpcë</option>
                        <option value="Novobërdë">Novobërdë</option>
                        <option value="Zubin Potok">Zubin Potok</option>
                        <option value="Junik">Junik</option>
                        <option value="Mamushë">Mamushë</option>
                        <option value="Ranillug">Ranillug</option>
                        <option value="Kllokot">Kllokot</option>
                        <option value="Parteshi">Parteshi</option>
                      </select>
                      {errors.city && (
                        <span className="validationError">
                          Qyteti është i detyrueshëm
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="PhoneField">
                  <div className="form-group form-group">
                    <label htmlFor="registerTelephone" className="">
                      Numri i telefonit
                    </label>
                    <div className="PhoneField__wrapper">
                      <select
                        id="registerPrefixTelephone"
                        className="PhoneField__wrapper--select form-control"
                        aria-invalid="false"
                        value={phonePrefix}
                        onChange={(e) => setPhonePrefix(e.target.value)}
                      >
                        <option value="+383">
                          🇽🇰+383
                        </option>
                        <option value="+355">🇦🇱+355</option>
                        <option value="+93">🇦🇫+93</option>
                        <option value="+358">🇦🇽+358</option>
                        <option value="+213">🇩🇿+213</option>
                        <option value="+1684">🇦🇸+1684</option>
                        <option value="+376">🇦🇩+376</option>
                        <option value="+244">🇦🇴+244</option>
                        <option value="+1264">🇦🇮+1264</option>
                        <option value="+672">🇦🇶+672</option>
                        <option value="+1268">🇦🇬+1268</option>
                        <option value="+54">🇦🇷+54</option>
                        <option value="+374">🇦🇲+374</option>
                        <option value="+297">🇦🇼+297</option>
                        <option value="+61">🇦🇺+61</option>
                        <option value="+43">🇦🇹+43</option>
                        <option value="+994">🇦🇿+994</option>
                        <option value="+1242">🇧🇸+1242</option>
                        <option value="+973">🇧🇭+973</option>
                        <option value="+880">🇧🇩+880</option>
                        <option value="+1246">🇧🇧+1246</option>
                        <option value="+375">🇧🇾+375</option>
                        <option value="+32">🇧🇪+32</option>
                        <option value="+501">🇧🇿+501</option>
                        <option value="+229">🇧🇯+229</option>
                        <option value="+1441">🇧🇲+1441</option>
                        <option value="+975">🇧🇹+975</option>
                        <option value="+591">🇧🇴+591</option>
                        <option value="+387">🇧🇦+387</option>
                        <option value="+267">🇧🇼+267</option>
                        <option value="+47">🇧🇻+47</option>
                        <option value="+55">🇧🇷+55</option>
                        <option value="+246">🇮🇴+246</option>
                        <option value="+673">🇧🇳+673</option>
                        <option value="+359">🇧🇬+359</option>
                        <option value="+226">🇧🇫+226</option>
                        <option value="+257">🇧🇮+257</option>
                        <option value="+855">🇰🇭+855</option>
                        <option value="+237">🇨🇲+237</option>
                        <option value="+1">🇨🇦+1</option>
                        <option value="+238">🇨🇻+238</option>
                        <option value="+345">🇰🇾+345</option>
                        <option value="+236">🇨🇫+236</option>
                        <option value="+235">🇹🇩+235</option>
                        <option value="+56">🇨🇱+56</option>
                        <option value="+86">🇨🇳+86</option>
                        <option value="+61">🇨🇽+61</option>
                        <option value="+61">🇨🇨+61</option>
                        <option value="+57">🇨🇴+57</option>
                        <option value="+269">🇰🇲+269</option>
                        <option value="+242">🇨🇬+242</option>
                        <option value="+243">🇨🇩+243</option>
                        <option value="+682">🇨🇰+682</option>
                        <option value="+506">🇨🇷+506</option>
                        <option value="+225">🇨🇮+225</option>
                        <option value="+385">🇭🇷+385</option>
                        <option value="+53">🇨🇺+53</option>
                        <option value="+357">🇨🇾+357</option>
                        <option value="+420">🇨🇿+420</option>
                        <option value="+45">🇩🇰+45</option>
                        <option value="+253">🇩🇯+253</option>
                        <option value="+1767">🇩🇲+1767</option>
                        <option value="+1849">🇩🇴+1849</option>
                        <option value="+593">🇪🇨+593</option>
                        <option value="+20">🇪🇬+20</option>
                        <option value="+503">🇸🇻+503</option>
                        <option value="+240">🇬🇶+240</option>
                        <option value="+291">🇪🇷+291</option>
                        <option value="+372">🇪🇪+372</option>
                        <option value="+251">🇪🇹+251</option>
                        <option value="+500">🇫🇰+500</option>
                        <option value="+298">🇫🇴+298</option>
                        <option value="+679">🇫🇯+679</option>
                        <option value="+358">🇫🇮+358</option>
                        <option value="+33">🇫🇷+33</option>
                        <option value="+594">🇬🇫+594</option>
                        <option value="+689">🇵🇫+689</option>
                        <option value="+262">🇹🇫+262</option>
                        <option value="+241">🇬🇦+241</option>
                        <option value="+220">🇬🇲+220</option>
                        <option value="+995">🇬🇪+995</option>
                        <option value="+49">🇩🇪+49</option>
                        <option value="+233">🇬🇭+233</option>
                        <option value="+350">🇬🇮+350</option>
                        <option value="+30">🇬🇷+30</option>
                        <option value="+299">🇬🇱+299</option>
                        <option value="+1473">🇬🇩+1473</option>
                        <option value="+590">🇬🇵+590</option>
                        <option value="+1671">🇬🇺+1671</option>
                        <option value="+502">🇬🇹+502</option>
                        <option value="+44">🇬🇬+44</option>
                        <option value="+224">🇬🇳+224</option>
                        <option value="+245">🇬🇼+245</option>
                        <option value="+592">🇬🇾+592</option>
                        <option value="+509">🇭🇹+509</option>
                        <option value="+672">🇭🇲+672</option>
                        <option value="+379">🇻🇦+379</option>
                        <option value="+504">🇭🇳+504</option>
                        <option value="+852">🇭🇰+852</option>
                        <option value="+36">🇭🇺+36</option>
                        <option value="+354">🇮🇸+354</option>
                        <option value="+91">🇮🇳+91</option>
                        <option value="+62">🇮🇩+62</option>
                        <option value="+98">🇮🇷+98</option>
                        <option value="+964">🇮🇶+964</option>
                        <option value="+353">🇮🇪+353</option>
                        <option value="+44">🇮🇲+44</option>
                        <option value="+972">🇮🇱+972</option>
                        <option value="+39">🇮🇹+39</option>
                        <option value="+1876">🇯🇲+1876</option>
                        <option value="+81">🇯🇵+81</option>
                        <option value="+44">🇯🇪+44</option>
                        <option value="+962">🇯🇴+962</option>
                        <option value="+7">🇰🇿+7</option>
                        <option value="+254">🇰🇪+254</option>
                        <option value="+686">🇰🇮+686</option>
                        <option value="+850">🇰🇵+850</option>
                        <option value="+82">🇰🇷+82</option>
                        <option value="+965">🇰🇼+965</option>
                        <option value="+996">🇰🇬+996</option>
                        <option value="+856">🇱🇦+856</option>
                        <option value="+371">🇱🇻+371</option>
                        <option value="+961">🇱🇧+961</option>
                        <option value="+266">🇱🇸+266</option>
                        <option value="+231">🇱🇷+231</option>
                        <option value="+218">🇱🇾+218</option>
                        <option value="+423">🇱🇮+423</option>
                        <option value="+370">🇱🇹+370</option>
                        <option value="+352">🇱🇺+352</option>
                        <option value="+853">🇲🇴+853</option>
                        <option value="+389">🇲🇰+389</option>
                        <option value="+261">🇲🇬+261</option>
                        <option value="+265">🇲🇼+265</option>
                        <option value="+60">🇲🇾+60</option>
                        <option value="+960">🇲🇻+960</option>
                        <option value="+223">🇲🇱+223</option>
                        <option value="+356">🇲🇹+356</option>
                        <option value="+692">🇲🇭+692</option>
                        <option value="+596">🇲🇶+596</option>
                        <option value="+222">🇲🇷+222</option>
                        <option value="+230">🇲🇺+230</option>
                        <option value="+262">🇾🇹+262</option>
                        <option value="+52">🇲🇽+52</option>
                        <option value="+691">🇫🇲+691</option>
                        <option value="+373">🇲🇩+373</option>
                        <option value="+377">🇲🇨+377</option>
                        <option value="+976">🇲🇳+976</option>
                        <option value="+382">🇲🇪+382</option>
                        <option value="+1664">🇲🇸+1664</option>
                        <option value="+212">🇲🇦+212</option>
                        <option value="+258">🇲🇿+258</option>
                        <option value="+95">🇲🇲+95</option>
                        <option value="+264">🇳🇦+264</option>
                        <option value="+674">🇳🇷+674</option>
                        <option value="+977">🇳🇵+977</option>
                        <option value="+31">🇳🇱+31</option>
                        <option value="+599">+599</option>
                        <option value="+687">🇳🇨+687</option>
                        <option value="+64">🇳🇿+64</option>
                        <option value="+505">🇳🇮+505</option>
                        <option value="+227">🇳🇪+227</option>
                        <option value="+234">🇳🇬+234</option>
                        <option value="+683">🇳🇺+683</option>
                        <option value="+672">🇳🇫+672</option>
                        <option value="+1670">🇲🇵+1670</option>
                        <option value="+47">🇳🇴+47</option>
                        <option value="+968">🇴🇲+968</option>
                        <option value="+92">🇵🇰+92</option>
                        <option value="+680">🇵🇼+680</option>
                        <option value="+970">🇵🇸+970</option>
                        <option value="+507">🇵🇦+507</option>
                        <option value="+675">🇵🇬+675</option>
                        <option value="+595">🇵🇾+595</option>
                        <option value="+51">🇵🇪+51</option>
                        <option value="+63">🇵🇭+63</option>
                        <option value="+64">🇵🇳+64</option>
                        <option value="+48">🇵🇱+48</option>
                        <option value="+351">🇵🇹+351</option>
                        <option value="+1939">🇵🇷+1939</option>
                        <option value="+974">🇶🇦+974</option>
                        <option value="+40">🇷🇴+40</option>
                        <option value="+7">🇷🇺+7</option>
                        <option value="+250">🇷🇼+250</option>
                        <option value="+262">🇷🇪+262</option>
                        <option value="+590">🇧🇱+590</option>
                        <option value="+290">🇸🇭+290</option>
                        <option value="+1869">🇰🇳+1869</option>
                        <option value="+1758">🇱🇨+1758</option>
                        <option value="+590">🇲🇫+590</option>
                        <option value="+508">🇵🇲+508</option>
                        <option value="+1784">🇻🇨+1784</option>
                        <option value="+685">🇼🇸+685</option>
                        <option value="+378">🇸🇲+378</option>
                        <option value="+239">🇸🇹+239</option>
                        <option value="+966">🇸🇦+966</option>
                        <option value="+221">🇸🇳+221</option>
                        <option value="+381">🇷🇸+381</option>
                        <option value="+248">🇸🇨+248</option>
                        <option value="+232">🇸🇱+232</option>
                        <option value="+65">🇸🇬+65</option>
                        <option value="+421">🇸🇰+421</option>
                        <option value="+386">🇸🇮+386</option>
                        <option value="+677">🇸🇧+677</option>
                        <option value="+252">🇸🇴+252</option>
                        <option value="+27">🇿🇦+27</option>
                        <option value="+211">🇸🇸+211</option>
                        <option value="+500">🇬🇸+500</option>
                        <option value="+34">🇪🇸+34</option>
                        <option value="+94">🇱🇰+94</option>
                        <option value="+249">🇸🇩+249</option>
                        <option value="+597">🇸🇷+597</option>
                        <option value="+47">🇸🇯+47</option>
                        <option value="+268">🇸🇿+268</option>
                        <option value="+46">🇸🇪+46</option>
                        <option value="+41">🇨🇭+41</option>
                        <option value="+963">🇸🇾+963</option>
                        <option value="+886">🇹🇼+886</option>
                        <option value="+992">🇹🇯+992</option>
                        <option value="+255">🇹🇿+255</option>
                        <option value="+66">🇹🇭+66</option>
                        <option value="+670">🇹🇱+670</option>
                        <option value="+228">🇹🇬+228</option>
                        <option value="+690">🇹🇰+690</option>
                        <option value="+676">🇹🇴+676</option>
                        <option value="+1868">🇹🇹+1868</option>
                        <option value="+216">🇹🇳+216</option>
                        <option value="+90">🇹🇷+90</option>
                        <option value="+993">🇹🇲+993</option>
                        <option value="+1649">🇹🇨+1649</option>
                        <option value="+688">🇹🇻+688</option>
                        <option value="+256">🇺🇬+256</option>
                        <option value="+380">🇺🇦+380</option>
                        <option value="+971">🇦🇪+971</option>
                        <option value="+44">🇬🇧+44</option>
                        <option value="+1">🇺🇸+1</option>
                        <option value="+598">🇺🇾+598</option>
                        <option value="+998">🇺🇿+998</option>
                        <option value="+678">🇻🇺+678</option>
                        <option value="+58">🇻🇪+58</option>
                        <option value="+84">🇻🇳+84</option>
                        <option value="+1284">🇻🇬+1284</option>
                        <option value="+1340">🇻🇮+1340</option>
                        <option value="+681">🇼🇫+681</option>
                        <option value="+967">🇾🇪+967</option>
                        <option value="+260">🇿🇲+260</option>
                        <option value="+263">🇿🇼+263</option>
                      </select>
                      <input
                        id="registerTelephone"
                        type="text"
                        className="PhoneField__wrapper--field form-control form-control-custom form-control"
                        {...register("phone", { required: true })}
                      />
                    </div>
                    {errors.phone && (
                      <span className="validationError">
                        Numri i telefonit është i nevojshëm
                      </span>
                    )}
                  </div>
                </div>

                <div className="form-group form-group">
                  <label htmlFor="comment" className="">
                    Komenti juaj
                  </label>
                  <textarea
                    id="comment"
                    name="comment"
                    placeholder="Shënime për porosinë (opsional)"
                    className="form-control form-control"
                    aria-invalid="false"
                    onChange={(e) => setanyComment(e.target.value)}
                  ></textarea>
                  <div id="comment" className="invalid-feedback"></div>
                </div>
              </div>

              <div className="w-full lg:w-6/12 rightsection">
                <div
                  id="boxes-shipping-section"
                  className="ShippingMethod"
                  onChange={radioHandler}
                >
                  <h4 className="ShippingMethod__title">Dërgesa</h4>
                  {!!deliverModex && (
                    <span className="validationError">{deliverModex}</span>
                  )}

                  <div className="ShippingMethod__item">
                    <label htmlFor="pm-free_shipping:3">
                      <input
                        id="pm-free_shipping:3"
                        name="shippingMethod"
                        hidden="hidden"
                        type="radio"
                        className="form-check-input"
                        value="t,3"
                        checked={getShippingLetter(deliverMode) === "t"}
                        onChange={radioHandler}
                      />
                      <span className="name">Transporti Standard</span>
                      <span className="price">
                        {getShippingPriceForTotal(
                          checkoutTotals.merchandise,
                          phonePrefix
                        ).toFixed(2)}{" "}
                        {process.env.REACT_APP_CURRENCY}
                      </span>
                    </label>
                  </div>

                  <div className="ShippingMethod__item ShippingMethod__item--boxes">
                    <label htmlFor="pm-boxes">
                      <input
                        id="pm-boxes"
                        name="shippingMethod"
                        hidden="hidden"
                        type="radio"
                        className="form-check-input"
                        value="b,3"
                        checked={getShippingLetter(deliverMode) === "b"}
                        onChange={radioHandler}
                      />
                      <span className="name">
                        <span className="ShippingMethod__name-text">
                          <span className="ShippingMethod__name-title">Boxes</span>
                          <span className="ShippingMethod__name-desc">
                            Merre porosinë në një pikë Boxes pranë teje
                          </span>
                        </span>
                      </span>
                      <span className="price">
                        {getShippingPriceForTotal(
                          checkoutTotals.merchandise,
                          phonePrefix
                        ).toFixed(2)}{" "}
                        {process.env.REACT_APP_CURRENCY}
                      </span>
                    </label>
                  </div>

                  {getShippingLetter(deliverMode) === "b" && (
                    <div
                      className={`BoxesPicker${
                        boxesPickerClosed ? " BoxesPicker--collapsed" : ""
                      }`}
                    >
                      <div className="BoxesPicker__iframe-wrap">
                        <iframe
                          id="boxesFrame"
                          src={boxesIframeSrc}
                          title="Boxes Pick-Up Point Picker"
                          width="100%"
                          height="600"
                          className="BoxesPicker__iframe"
                          allow="geolocation"
                        />
                      </div>
                      <p
                        className={`BoxesPicker__hint${
                          boxesPickupData.BoxesId
                            ? " BoxesPicker__hint--hidden"
                            : ""
                        }`}
                      >
                        Zgjidhni një pikë mbledhjeje nga harta më poshtë.
                      </p>
                      {boxesPickupData.BoxesId ? (
                        <div className="BoxesPicker__selected">
                          <p className="BoxesPicker__selected-title">
                            Pikë Boxes e zgjedhur:
                          </p>
                          {boxesPickupData.BoxesName ? (
                            <p>
                              <strong>Pika:</strong> {boxesPickupData.BoxesName}
                            </p>
                          ) : null}
                          <p>
                            <strong>Adresa:</strong>{" "}
                            {boxesPickupData.BoxesAddress}
                          </p>
                          <p>
                            <strong>Qyteti:</strong> {boxesPickupData.BoxesCity}
                          </p>
                          {boxesPickerClosed && (
                            <button
                              type="button"
                              className="BoxesPicker__change-btn"
                              onClick={() => setBoxesPickerClosed(false)}
                            >
                              Ndrysho pikën
                            </button>
                          )}
                        </div>
                      ) : null}
                    </div>
                  )}
                </div>

                <div
                  id={"paymentMethod"}
                  className="PaymentMethod"
                  onChange={radioPaymentMode}
                >
                  <h4 className="PaymentMethod__title">Pagesa</h4>

                  <div className="PaymentMethod__item">
                    <label htmlFor="pm-procredit">
                      <input
                        id="pm-procredit"
                        name="paymentMethod"
                        hidden="hidden"
                        type="radio"
                        className="form-check-input"
                        value="credit_card"
                      />
                      <div className="name payment-option__label">
                        <span>Kartelë bankare</span>
                      </div>
                      <span className="secure-pay-badge">
                        <svg
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2.2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          aria-hidden
                        >
                          <rect x="4" y="11" width="16" height="9" rx="2" />
                          <path d="M8 11V7a4 4 0 0 1 8 0v4" />
                        </svg>
                        Pagesë e sigurt
                      </span>
                      <span className="procredit-icon" aria-hidden />
                    </label>
                  </div>

                  {transportCharge === 3 && (
                    <div className="PaymentMethod__item">
                      <label htmlFor="pm-cod">
                        <input
                          id="pm-cod"
                          name="paymentMethod"
                          hidden="hidden"
                          type="radio"
                          className="form-check-input"
                          value="cod"
                        />
                        <div className="name payment-option__label">
                          <span>Para në dorë</span>
                        </div>
                        <span className="cod-pay-badge">
                          <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            aria-hidden
                          >
                            <rect x="2" y="6" width="20" height="12" rx="2" />
                            <circle cx="12" cy="12" r="3" />
                          </svg>
                          Paguaj në dorëzim
                        </span>
                        <span className="cod-icon" aria-hidden />
                      </label>
                    </div>
                  )}

                  {paymentModex && (
                    <div>
                      <span className="validationError">{paymentModex}</span>
                    </div>
                  )}
                </div>

                <div id={"orderDelivery"} className="OrderDetails">
                  <div className="OrderDetails__table">
                    <h4 className="OrderDetails__table__title">Shporta</h4>
                    <div className="OrderDetails__table__thead">
                      <strong className="half">Produkti</strong>
                      <strong>Sasia</strong>
                      <strong>Çmimi</strong>
                    </div>

                    {cartData.map((dtt) => {
                      const promoItem =
                        promotionSummary.items?.find(
                          (pi) =>
                            (pi.uniqueId &&
                              pi.uniqueId === dtt.uniqueId) ||
                            (!pi.uniqueId &&
                              pi.externalId === (dtt._id || dtt.externalId) &&
                              pi.item_code === dtt.item_code)
                        ) || null;

                      const rowKey = dtt.uniqueId || `${dtt._id}-${dtt.item_code}`;
                      const rowCouponDiscountTotal = Number(
                        promocodeAllocation.byKey?.[rowKey] || 0
                      );
                      const rowLoyaltyDiscountTotal = Number(
                        loyaltyAllocation.byKey?.[rowKey] || 0
                      );
                      const qty = Number(dtt?.quantity || 1);
                      const effectiveUnit = getCartItemUnitPrice(dtt, promoItem);
                      const rowCouponPerUnit =
                        rowCouponDiscountTotal > 0 && qty > 0
                          ? Number((rowCouponDiscountTotal / qty).toFixed(2))
                          : 0;
                      const rowLoyaltyPerUnit =
                        rowLoyaltyDiscountTotal > 0 && qty > 0
                          ? Number((rowLoyaltyDiscountTotal / qty).toFixed(2))
                          : 0;
                      const extraPerUnit = Number(
                        (rowCouponPerUnit + rowLoyaltyPerUnit).toFixed(2)
                      );
                      const couponAdjustedUnit =
                        extraPerUnit > 0
                          ? Number(Math.max(0, effectiveUnit - extraPerUnit).toFixed(2))
                          : effectiveUnit;

                      return (
                        <div className="OrderDetails__table__item" key={dtt.uniqueId || `${dtt._id}-${dtt.item_code}`}>
                          <div className="OrderDetails__table__item__name">
                            <div className="OrderDetails__table__item_image">
                              <img src={dtt?.images[0]} alt="cG9zdDoyNzgwMTE=" />
                            </div>
                            <span className="half cart-checkout">
                              {dtt?.name} - {dtt?.size}
                            </span>
                          </div>
                          <span>{dtt?.quantity}</span>
                          <div className="ProductPrices">
                            {(() => {
                              // Nëse ky artikull është në promotion-preview, përdor çmimin bazë + të zbritur
                              if (promoItem && promoItem.finalUnitPrice < promoItem.baseUnitPrice) {
                                const promoUnit = Number(promoItem.finalUnitPrice || 0);
                                const finalUnit = couponAdjustedUnit;
                                const showCouponDiscount =
                                  extraPerUnit > 0 && finalUnit < promoUnit;

                                return (
                                  <>
                                    <h4
                                      className="regular"
                                      style={{
                                        textDecoration: "line-through",
                                        color: "#999",
                                        fontSize: "12px",
                                        marginRight: "8px",
                                      }}
                                    >
                                      {promoItem.baseUnitPrice.toFixed(2)}{" "}
                                      {process.env.REACT_APP_CURRENCY}
                                    </h4>
                                    <h4
                                      className="regular"
                                      style={
                                        showCouponDiscount
                                          ? {
                                              textDecoration: "line-through",
                                              color: "#999",
                                              fontSize: "12px",
                                              marginRight: "8px",
                                            }
                                          : undefined
                                      }
                                    >
                                      {promoUnit.toFixed(2)}{" "}
                                      {process.env.REACT_APP_CURRENCY}
                                    </h4>
                                    {showCouponDiscount && (
                                      <h4 className="regular">
                                        {finalUnit.toFixed(2)}{" "}
                                        {process.env.REACT_APP_CURRENCY}
                                      </h4>
                                    )}
                                  </>
                                );
                              }

                              // Përndryshe, përdor logjikën ekzistuese të displayPrice
                              const displayPrice = getDisplayPrice(dtt);
                              const baseUnit = displayPrice.hasDiscount2 && displayPrice.sale2 > 0
                                ? Number(displayPrice.sale2 || 0)
                                : displayPrice.hasDiscount && displayPrice.sale > 0
                                ? Number(displayPrice.sale || 0)
                                : Number(displayPrice.regular || 0);
                              const showCouponDiscount =
                                extraPerUnit > 0 && couponAdjustedUnit < baseUnit;

                              return (
                                <>
                                  {displayPrice.hasDiscount2 && displayPrice.sale2 > 0 ? (
                                    <>
                                      <h4
                                        className="regular"
                                        style={{
                                          textDecoration: "line-through",
                                          color: "#999",
                                          fontSize: "12px",
                                          marginRight: "8px",
                                        }}
                                      >
                                        {displayPrice.regular?.toFixed(2)}
                                      </h4>
                                      {displayPrice.sale > 0 && (
                                        <h4
                                          className="regular"
                                          style={{
                                            textDecoration: "line-through",
                                            color: "#999",
                                            fontSize: "12px",
                                            marginRight: "8px",
                                          }}
                                        >
                                          {displayPrice.sale?.toFixed(2)}
                                        </h4>
                                      )}
                                      <h4
                                        className="regular"
                                        style={
                                          showCouponDiscount
                                            ? {
                                                textDecoration: "line-through",
                                                color: "#999",
                                                fontSize: "12px",
                                                marginRight: "8px",
                                              }
                                            : undefined
                                        }
                                      >
                                        {displayPrice.sale2?.toFixed(2)}{" "}
                                        {process.env.REACT_APP_CURRENCY}
                                      </h4>
                                      {showCouponDiscount && (
                                        <h4 className="regular">
                                          {couponAdjustedUnit.toFixed(2)}{" "}
                                          {process.env.REACT_APP_CURRENCY}
                                        </h4>
                                      )}
                                    </>
                                  ) : displayPrice.hasDiscount && displayPrice.sale > 0 ? (
                                    <>
                                      <h4
                                        className="regular"
                                        style={{
                                          textDecoration: "line-through",
                                          color: "#999",
                                          fontSize: "12px",
                                          marginRight: "8px",
                                        }}
                                      >
                                        {displayPrice.regular?.toFixed(2)}
                                      </h4>
                                      <h4
                                        className="regular"
                                        style={
                                          showCouponDiscount
                                            ? {
                                                textDecoration: "line-through",
                                                color: "#999",
                                                fontSize: "12px",
                                                marginRight: "8px",
                                              }
                                            : undefined
                                        }
                                      >
                                        {displayPrice.sale?.toFixed(2)}{" "}
                                        {process.env.REACT_APP_CURRENCY}
                                      </h4>
                                      {showCouponDiscount && (
                                        <h4 className="regular">
                                          {couponAdjustedUnit.toFixed(2)}{" "}
                                          {process.env.REACT_APP_CURRENCY}
                                        </h4>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      <h4
                                        className="regular"
                                        style={
                                          showCouponDiscount
                                            ? {
                                                textDecoration: "line-through",
                                                color: "#999",
                                                fontSize: "12px",
                                                marginRight: "8px",
                                              }
                                            : undefined
                                        }
                                      >
                                        {displayPrice.regular?.toFixed(2)}{" "}
                                        {process.env.REACT_APP_CURRENCY}
                                      </h4>
                                      {showCouponDiscount && (
                                        <h4 className="regular">
                                          {couponAdjustedUnit.toFixed(2)}{" "}
                                          {process.env.REACT_APP_CURRENCY}
                                        </h4>
                                      )}
                                    </>
                                  )}
                                </>
                              );
                            })()}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <div className="ApplyCoupon">
                  <div className="ApplyCoupon__toggleBar">
                    <div className="ApplyCoupon__toggleLeft">
                      <span className="ApplyCoupon__toggleTitle">Kodi i kuponit</span>
                      <p className="ApplyCoupon__toggleHint">
                        Keni një kod promocional? Shkruaj këtu
                      </p>
                      {!showPromoSection && promocodeApplied?.code ? (
                        <span className="ApplyCoupon__toggleBadge">{promocodeApplied.code}</span>
                      ) : null}
                    </div>
                    <button
                      type="button"
                      className="ApplyCoupon__toggleBtn"
                      onClick={() => setShowPromoSection((prev) => !prev)}
                      aria-expanded={showPromoSection}
                    >
                      {showPromoSection ? "Fshih" : "Shfaq"}
                    </button>
                  </div>

                  {showPromoSection ? (
                  <div className="ApplyCoupon__form">
                    <div className="ApplyCoupon__row">
                      <div className="ApplyCoupon__left">
                        <label htmlFor="coupon" className="ApplyCoupon__label">
                        Kodi i kuponit
                        </label>
                        <div className="ApplyCoupon__inputWrap">
                          <input
                            id="coupon"
                            name="coupon"
                            type="text"
                            className="ApplyCoupon__input"
                            placeholder="Shkruaj kodin"
                            value={promocodeInput}
                            onChange={(e) => setPromocodeInput(e.target.value)}
                            autoComplete="off"
                          />
                          <button
                            type="button"
                            className="ApplyCoupon__btn"
                            onClick={applyPromocode}
                            disabled={!String(promocodeInput || "").trim()}
                          >
                            APLIKO
                          </button>
                        </div>
                      </div>

                      <div className="ApplyCoupon__right">
                        {promocodeApplied?.code ? (
                          <div className="ApplyCoupon__card" aria-label="Kodi i kuponit i aplikuar">
                            <div className="ApplyCoupon__cardTop">
                              <div className="ApplyCoupon__cardTitle">
                              Kodi i kuponit i aplikuar
                              </div>
                              <button
                                type="button"
                                className="ApplyCoupon__cardClose"
                                onClick={clearPromocode}
                                aria-label="Hiq kodin promocional"
                                title="Hiq kodin promocional"
                              >
                                ×
                              </button>
                            </div>

                            <div className="ApplyCoupon__cardCode">
                              {promocodeApplied.code}
                            </div>

                            <div className="ApplyCoupon__cardMeta">
                              <div className="ApplyCoupon__cardRow">
                                <span className="ApplyCoupon__cardKey">Zbritja</span>
                                <span className="ApplyCoupon__cardVal">
                                  {promocodeApplied?.discount?.type === "percentage"
                                    ? `${Number(promocodeApplied?.discount?.value || 0)}%`
                                    : `${Number(
                                        promocodeApplied?.discount?.amount ??
                                          calculatePromocodeAmountLocal(promocodeApplied) ??
                                          0
                                      ).toFixed(2)}${process.env.REACT_APP_CURRENCY}`}
                                </span>
                              </div>
                              <div className="ApplyCoupon__cardRow">
                                <span className="ApplyCoupon__cardKey">Ulje totale</span>
                                <span className="ApplyCoupon__cardVal">
                                  -{Number(promocodeAllocation?.total || 0).toFixed(2)}
                                  {process.env.REACT_APP_CURRENCY}
                                </span>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="ApplyCoupon__hint">
                            Kodi promocional (opsional)
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  ) : null}
                </div>

                {/* LOYALTY_UI_DISABLED
                <div className="ApplyLoyalty">
                  {loyaltyApplied?.code ? (
                    (() => {
                      const hasLoyaltyDiscount =
                        Number(loyaltyAllocation.percent) > 0 &&
                        Number(loyaltyAllocation.total) > 0;
                      const pointsEarned = Math.max(
                        0,
                        Math.round(Number(checkoutTotals.baseTotal || 0))
                      );
                      const showBoth = hasLoyaltyDiscount && pointsEarned > 0;

                      return (
                        <div
                          className={`ApplyLoyalty__stats${
                            showBoth ? " ApplyLoyalty__stats--split" : ""
                          }`}
                        >
                          {hasLoyaltyDiscount ? (
                            <div className="ApplyLoyalty__stat ApplyLoyalty__stat--discount">
                              <strong>
                                {formatLoyaltyPercent(loyaltyAllocation.percent)}%
                              </strong>
                              <span>Zbritje loyalty</span>
                            </div>
                          ) : null}
                          {pointsEarned > 0 ? (
                            <div className="ApplyLoyalty__stat ApplyLoyalty__stat--points">
                              <strong>{pointsEarned}</strong>
                              <span>Pikë të fituara</span>
                            </div>
                          ) : null}
                          <button
                            type="button"
                            className="ApplyLoyalty__moreBtn"
                            onClick={() => setLoyaltyHelpOpen(true)}
                          >
                            Si funksionon?
                          </button>
                        </div>
                      );
                    })()
                  ) : (
                    <div className="ApplyLoyalty__promo">
                      <button
                        type="button"
                        className="ApplyLoyalty__helpBtn"
                        onClick={() => setLoyaltyHelpOpen(true)}
                      >
                        Si të përfitosh zbritje tani?
                      </button>
                    </div>
                  )}
                </div>
                */}
              </div>
            </div>

            <div className="flex w-full mob-flex-col justify-end">
              <div className="w-full lg:w-6/12 mob-pad">
                <div className="CheckoutFooter">
                  <div className="row">
                    <div className="ml-auto w-full">
                      <div className="mb-5 terms-sec">
                        <div className="flex items-center gap-3">
                          <input
                            id="abonohu"
                            type="checkbox"
                            className="h-4 w-4 rounded border-gray-300 accent-indigo-600"
                            required
                            {...register("abonohu")}
                          />
                          <label
                            htmlFor="abonohu"
                            className="text-sm text-gray-700 cursor-pointer"
                          >
                            <a
                              href="/terms-conditions"
                              target="_blank"
                              className="text-blue-600 hover:text-blue-800 underline hover:underline-offset-2 transition-colors duration-200"
                            >
                              Pajtohem me kushtet e blerjes
                            </a>
                          </label>
                        </div>

                        <div className="flex items-center gap-3">
                          <input
                            id="abonohu-newsletter"
                            type="checkbox"
                            className="h-4 w-4 rounded border-gray-300 accent-indigo-600"
                            {...register("newsletter")}
                          />
                          <label
                            htmlFor="abonohu-newsletter"
                            className="text-sm text-gray-700 cursor-pointer"
                          >
                            Abonohu për të rejat
                          </label>
                        </div>
                      </div>

                      <div className="checkout-premium__summary-bar sm:flex sm:justify-between sm:items-center sm:border border-gray-200 p-2 mb-5">
                        <div className="CartTotal__Price">
                          {(() => {
                            const {
                              baseTotal,
                              promoDiscount,
                              couponDiscount,
                              // loyaltyDiscount,
                              merchandise,
                            } = checkoutTotals;
                            const summaryLetter = getShippingLetter(deliverMode);
                            const shipping =
                              summaryLetter === "p"
                                ? 0
                                : getShippingPriceForTotal(
                                    merchandise,
                                    phonePrefix
                                  );
                            const finalTotal = merchandise + shipping;
                            // LOYALTY_UI_DISABLED
                            // const loyaltyPercentLabel = formatLoyaltyPercent(
                            //   loyaltyAllocation.percent || loyaltyApplied?.percent
                            // );

                            return (
                              <>
                                <div>
                                  Subtotali
                                  <strong>
                                    {baseTotal.toFixed(2)}
                                    {process.env.REACT_APP_CURRENCY}
                                  </strong>
                                </div>
                                {promoDiscount > 0 && (
                                  <div>
                                    Zbritje promocionale
                                    <strong>
                                      -{promoDiscount.toFixed(2)}
                                      {process.env.REACT_APP_CURRENCY}
                                    </strong>
                                  </div>
                                )}
                                {couponDiscount > 0 && (
                                  <div>
                                    Zbritje promocionale
                                    <strong>
                                      -{couponDiscount.toFixed(2)}
                                      {process.env.REACT_APP_CURRENCY}
                                    </strong>
                                  </div>
                                )}
                                {/* LOYALTY_UI_DISABLED
                                {loyaltyDiscount > 0 && (
                                  <div>
                                    Zbritje loyalty
                                    <strong>
                                      -{loyaltyDiscount.toFixed(2)}
                                      {process.env.REACT_APP_CURRENCY}
                                    </strong>
                                  </div>
                                )}
                                */}
                                {summaryLetter !== "p" && (
                                  <div>
                                    {summaryLetter === "b"
                                      ? "Dorëzimi Boxes"
                                      : "Transporti"}
                                    <strong>
                                      {shipping > 0 ? (
                                        <>
                                          {shipping.toFixed(2)}
                                          {process.env.REACT_APP_CURRENCY}
                                        </>
                                      ) : (
                                        <>Falas</>
                                      )}
                                    </strong>
                                  </div>
                                )}
                                <div>
                                  Totali
                                  <strong>
                                    {finalTotal.toFixed(2)}
                                    {process.env.REACT_APP_CURRENCY}
                                  </strong>
                                </div>
                                {promoDiscount > 0 &&
                                  promotionSummary.appliedPromotions?.[0]?.name && (
                                    <div className="text-xs text-gray-500">
                                      Promo:{" "}
                                      {promotionSummary.appliedPromotions[0].name}
                                    </div>
                                  )}
                                {couponDiscount > 0 && promocodeApplied?.code && (
                                  <div className="text-xs text-gray-500">
                                    Kodi i kuponit: {promocodeApplied.code}
                                  </div>
                                )}
                                {/* {loyaltyPercentLabel && isLoggedIn && (
                                  <div className="text-xs text-gray-500">
                                    {loyaltyPercentLabel}% zbritje e fituar për klientët tanë besnikë
                                  </div>
                                )} */}
                                <span>Përfshirë TVSH </span>
                              </>
                            );
                          })()}
                        </div>

                        <div className="w-full sm:w-6/12 bg-black text-center text-white py-2 mt-2 sm:mt-0 ">
                          <button
                            aria-current="page"
                            className="btn btn-success active text-white"
                            type="submit"
                            disabled={loadingBox}
                          >
                            {loadingBox ? "DUKE PROCESUAR..." : "VAZHDO ME BLERJEN"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>

      {paymentMode === "credit_card" ? (
        <form
          method="post"
          id="pymntForm"
          action="https://pgw.bkt-ks.com/fim/est3Dgate"
        >
          {/* <form method="post" id="pymntForm" action="https://entegrasyon.asseco-see.com.tr/fim/est3Dgate"> */}
          <input
            type="hidden"
            name="clientid"
            value={paymentParams?.clientId}
          />
          <input type="hidden" name="amount" value={paymentParams?.amount} />
          <input
            type="hidden"
            name="islemtipi"
            value={paymentParams?.transactionType}
          />
          <input
            type="hidden"
            name="taksit"
            value={paymentParams?.instalment}
          />
          <input type="hidden" name="oid" value={paymentParams?.oid} />
          <input type="hidden" name="okUrl" value={paymentParams?.okUrl} />
          <input type="hidden" name="failUrl" value={paymentParams?.failUrl} />
          <input type="hidden" name="rnd" value={paymentParams?.rnd} />
          <input type="hidden" name="hash" value={paymentParams?.hashstr} />
          <input
            type="hidden"
            name="storetype"
            value={paymentParams?.storetype}
          />
          <input type="hidden" name="lang" value={paymentParams?.lang} />
          <input
            type="hidden"
            name="currency"
            value={paymentParams?.currencyVal}
          />
        </form>
      ) : (
        ""
      )}
      <Footer />
    </>
  );
}
